<div class="sdp-section-container sdp-forgot-password-section-container">
	<mat-card>
		<div class="sdp-section-header-container">{{ "forgotpassword.title" | translate }}</div>
		<div *ngIf="isStateInitial">
			<sdp-forgot-password-form (showLoadingBar)="showLoadingBar()" (hideLoadingBar)="hideLoadingBar()" (showPendingEmail)="showPendingEmail($event)"></sdp-forgot-password-form>
		</div>
		<div *ngIf="isStateEmailPending">
			<sdp-forgot-password-email-pending (showLoadingBar)="showLoadingBar()" (hideLoadingBar)="hideLoadingBar()" [email]="email"></sdp-forgot-password-email-pending>
		</div>
		<div *ngIf="isStateChange">
			<sdp-forgot-password-change (showLoadingBar)="showLoadingBar()" (hideLoadingBar)="hideLoadingBar()"></sdp-forgot-password-change>
		</div>
		<mat-progress-bar mode="indeterminate" *ngIf="isPasswordLoading" class="sdp-progress-bar-bottom"></mat-progress-bar>
	</mat-card>
</div>